import { type FC, type ReactNode } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'

export interface OnboardingStepFrameProps {
  onBack?: () => void
  onSkip?: () => void
  skipLabel?: string
  children: ReactNode
}

export const OnboardingStepContent: FC<{ children: ReactNode }> = ({ children }) => (
  <Row className='justify-content-center g-0 w-100'>
    <Col xs={12} md={9} lg={7} xl={6} className='d-flex flex-column align-items-center gap-4'>
      {children}
    </Col>
  </Row>
)

export const OnboardingStepFrame: FC<OnboardingStepFrameProps> = ({ onBack, onSkip, skipLabel = 'Skip this step', children }) => (
  <div className='position-relative border rounded-3 zocks-border-color-gray-300 w-100 p-4'>
    {onBack ? (
      <Button variant='secondaryGhostButton' className='position-absolute top-0 start-0 m-3 p-2' onClick={onBack} aria-label='Back'>
        <i className='bi bi-chevron-left' />
      </Button>
    ) : null}
    {onSkip ? (
      <Button variant='primaryLinkButton' className='position-absolute top-0 end-0 m-3 p-0 text-decoration-none' onClick={onSkip}>
        {skipLabel}
      </Button>
    ) : null}
    <div className='d-flex flex-column align-items-center gap-4'>{children}</div>
  </div>
)
